interface SpecCard {
  icon: string;
  tag: string;
  title: string;
  description: string;
  metric: string;
  metricLabel: string;
}

const specs: SpecCard[] = [
  {
    icon: 'ri-flashlight-line',
    tag: 'Cellular Energy',
    title: 'ATP Synthesis',
    description:
      'Cordymax acts as a true, non-stimulant cellular energy source by integrating directly into adenylate metabolism — fueling mitochondrial output without relying on CNS stimulation.',
    metric: '↑ ATP',
    metricLabel: 'Non-stimulant pathway',
  },
  {
    icon: 'ri-lungs-line',
    tag: 'Aerobic Capacity',
    title: 'Nitric Oxide',
    description:
      'Enhances vasodilation for clinically backed VO₂ max improvements. Cordycepin upregulates eNOS activity, expanding peripheral oxygen delivery and delaying lactate threshold.',
    metric: '↑ VO₂',
    metricLabel: 'Vasodilatory support',
  },
  {
    icon: 'ri-shield-check-line',
    tag: 'Sustained Output',
    title: 'Zero Crash',
    description:
      'Sustained performance without adenosine-blocking jitters. Unlike caffeine, cordycepin does not occupy adenosine receptors — providing clean energy with no rebound fatigue or sleep disruption.',
    metric: '0 Crash',
    metricLabel: 'No adenosine block',
  },
];

export default function TechSpecsSection() {
  return (
    <section id="specs" className="bg-white py-12 px-6 border-t border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-8">
          <div>
            <p
              className="text-xs font-semibold tracking-widest uppercase text-[#2563EB] mb-1"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Mechanism of Action
            </p>
            <h2
              className="text-[#0F172A] text-3xl xl:text-4xl leading-tight"
              style={{ fontFamily: 'Inter, sans-serif', fontWeight: 800, letterSpacing: '-0.05em' }}
            >
              Technical Performance Data
            </h2>
          </div>
          <p className="text-sm text-[#475569] max-w-xs" style={{ fontFamily: 'Inter, sans-serif' }}>
            Full panel potency tests behind every standardized batch of Cordymax™.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {specs.map((card) => (
            <div
              key={card.title}
              className="border border-[#E2E8F0] rounded-lg p-6 flex flex-col gap-4 bg-white hover:border-[#2563EB]/40 transition-colors"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-md bg-[#F8F9FA] border border-[#E2E8F0]">
                  <i className={`${card.icon} text-[#2563EB] text-lg`}></i>
                </div>
                <span
                  className="text-xs font-semibold text-[#475569] bg-[#F8F9FA] border border-[#E2E8F0] px-2 py-0.5 rounded-full whitespace-nowrap"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  {card.tag}
                </span>
              </div>

              <div>
                <h3
                  className="text-[#0F172A] text-lg mb-2"
                  style={{ fontFamily: 'Inter, sans-serif', fontWeight: 700, letterSpacing: '-0.03em' }}
                >
                  {card.title}
                </h3>
                <p className="text-sm text-[#475569] leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
                  {card.description}
                </p>
              </div>

              <div className="mt-auto pt-3 border-t border-[#E2E8F0] flex items-center gap-2">
                <span
                  className="text-sm text-[#0F172A]"
                  style={{ fontFamily: 'Inter, sans-serif', fontWeight: 800 }}
                >
                  {card.metric}
                </span>
                <span className="text-xs text-[#475569]" style={{ fontFamily: 'Inter, sans-serif' }}>
                  — {card.metricLabel}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
